// Mock data for Sistema de Gestão de Instrumentos

export const mockInstruments = [
  {
    id: '1',
    nome: 'mocal25002',
    marca: 'mito',
    tipo: 'calibrador tampao',
    status: 'vencido',
    proximaCalibracao: '2024-01-15',
    responsavel: 'Anderson',
    faixaMedicao: '0-100 bar',
    setor: 'Qualidade',
    statusInstrumento: 'Estoque',
    observacoes: 'Instrumento de alta precisão',
    orcamentoNumero: 'ORC-2023-001',
    custoCalibracao: 1500.00,
    custoManutencao: 800.00,
    qrCodeUrl: 'https://sistema-gestao-instrumentos.com.br/cert/CERT-2023-001'
  },
  {
    id: '2',
    nome: 'ELHPU2001',
    marca: 'MITO',
    tipo: 'Paquímetro',
    status: 'em_estoque',
    proximaCalibracao: '2025-06-10',
    responsavel: 'Anderson',
    faixaMedicao: '0-150mm',
    setor: 'Produção',
    statusInstrumento: 'Emprestado',
    observacoes: 'Em boas condições',
    orcamentoNumero: 'ORC-2024-045',
    custoCalibracao: 850.00,
    custoManutencao: 450.00,
    qrCodeUrl: 'https://sistema-gestao-instrumentos.com.br/cert/CERT-2024-045'
  },
  {
    id: '3',
    nome: 'Micrômetro Digital MX500',
    marca: 'Mitutoyo',
    tipo: 'Micrômetro',
    status: 'em_estoque',
    proximaCalibracao: '2025-08-20',
    responsavel: 'Carlos Silva',
    faixaMedicao: '0-25mm',
    setor: 'Metrologia',
    statusInstrumento: 'Estoque',
    observacoes: 'Precisão 0.001mm',
    orcamentoNumero: 'ORC-2024-089',
    custoCalibracao: 1200.00,
    custoManutencao: 600.00,
    qrCodeUrl: 'https://sistema-gestao-instrumentos.com.br/cert/CERT-2024-089'
  },
  {
    id: '4',
    nome: 'Balança Analítica BA-210',
    marca: 'Shimadzu',
    tipo: 'Balança',
    status: 'vencido',
    proximaCalibracao: '2024-03-10',
    responsavel: 'Maria Santos',
    faixaMedicao: '0-210g',
    setor: 'Laboratório',
    statusInstrumento: 'Em manutenção',
    observacoes: 'Necessita recalibração urgente',
    orcamentoNumero: 'ORC-2023-034',
    custoCalibracao: 2500.00,
    custoManutencao: 1200.00,
    qrCodeUrl: 'https://sistema-gestao-instrumentos.com.br/cert/CERT-2023-034'
  },
  {
    id: '5',
    nome: 'Termômetro Digital TH-300',
    marca: 'Fluke',
    tipo: 'Termômetro',
    status: 'em_estoque',
    proximaCalibracao: '2025-05-15',
    responsavel: 'João Oliveira',
    faixaMedicao: '-50°C a 300°C',
    setor: 'Manutenção',
    statusInstrumento: 'Em calibração',
    observacoes: 'Alta precisão',
    orcamentoNumero: 'ORC-2024-067',
    custoCalibracao: 950.00,
    custoManutencao: 500.00,
    qrCodeUrl: 'https://sistema-gestao-instrumentos.com.br/cert/CERT-2024-067'
  },
  {
    id: '6',
    nome: 'Manômetro MP-1000',
    marca: 'Wika',
    tipo: 'Manômetro',
    status: 'em_estoque',
    proximaCalibracao: '2025-07-22',
    responsavel: 'Pedro Costa',
    faixaMedicao: '0-1000 PSI',
    setor: 'Engenharia',
    statusInstrumento: 'Estoque',
    observacoes: 'Pressão máxima 1000 PSI',
    orcamentoNumero: 'ORC-2024-078',
    custoCalibracao: 1100.00,
    custoManutencao: 700.00,
    qrCodeUrl: 'https://sistema-gestao-instrumentos.com.br/cert/CERT-2024-078'
  },
  {
    id: '7',
    nome: 'Calibrador de Pressão CP-500',
    marca: 'Fluke',
    tipo: 'calibrador tampao',
    status: 'vencido',
    proximaCalibracao: '2024-09-30',
    responsavel: 'Anderson',
    faixaMedicao: '0-500 bar',
    setor: 'Qualidade',
    statusInstrumento: 'Emprestado',
    observacoes: 'Calibração atrasada',
    orcamentoNumero: 'ORC-2023-112',
    custoCalibracao: 1800.00,
    custoManutencao: 900.00,
    qrCodeUrl: 'https://sistema-gestao-instrumentos.com.br/cert/CERT-2023-112'
  },
  {
    id: '8',
    nome: 'Paquímetro Digital PD-150',
    marca: 'Starrett',
    tipo: 'Paquímetro',
    status: 'em_estoque',
    proximaCalibracao: '2025-09-05',
    responsavel: 'Lucas Ferreira',
    faixaMedicao: '0-150mm',
    setor: 'Controle de Qualidade',
    statusInstrumento: 'Estoque',
    observacoes: 'Em perfeitas condições',
    orcamentoNumero: 'ORC-2024-098',
    custoCalibracao: 900.00,
    custoManutencao: 400.00,
    qrCodeUrl: 'https://sistema-gestao-instrumentos.com.br/cert/CERT-2024-098'
  }
];

export const instrumentTypes = [
  'Todos os tipos',
  'Paquímetro',
  'Micrômetro',
  'Balança',
  'Termômetro',
  'Manômetro',
  'calibrador tampao'
];

export const statusInstrumentoOptions = [
  'Estoque',
  'Emprestado',
  'Em manutenção',
  'Em calibração'
];

// QR Code data - cada instrumento tem seu próprio QR Code
export const generateQRCode = (url) => {
  return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(url)}`;
};